import { Component, OnInit, ViewEncapsulation, Input, Output, ElementRef, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { DialogService } from 'primeng/dynamicdialog';

import { UpdateContactDialogComponent } from '../update-contact-dialog/update-contact-dialog.component';
import { HelperService, DataService, HTTPService, SocketService } from 'app/services';

import { config } from 'app/constants';
import { MultiTechAssignDialogComponent } from 'app/modules/app-components';

import { Subject } from 'rxjs';
import { debounce } from 'lodash';

@Component({
  selector: 'app-notifications-sidepanel',
  templateUrl: './notifications-sidepanel.component.html',
  styleUrls: ['./notifications-sidepanel.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NotificationSidepanelComponent implements OnInit, OnDestroy {
  @Input() isSidebarVisible: boolean = false;
  @Output() setNotificationPanelState = new EventEmitter();
  @Output() fetchNotifications = new EventEmitter();
  @Output() dismissEvent = new EventEmitter();

  @ViewChild('sidebarContainer', { static: true }) sidebarContainer: ElementRef;
  @ViewChild('notificationsContainer', { static: true }) notificationsContainer: any;

  unsubscribe: Subject<boolean> = new Subject<boolean>();
  allNotifications: any[] = [];
  urgentNotificationsTotalRecord: number = 0;
  othersNotificationsTotalRecord: number = 0;
  customerNotifications = [];

  _notifications = {
    new: [],
    old: [],
  };
  contact: any = {};
  urgentNotifications: any = [];
  deletedElement: any = -1;
  lastScrollTop = 0;
  baseZIndex = 9999;
  // clickOutsideListener: any = null;
  unAssignTech: any = { isUnassignOption: true };
  dataListeners: any[] = [];
  index: number = 0;
  technicians: any[] = [];
  techEnabledStatus = false;
  isWorkAsTechEnabled: boolean = false;
  urgentnotificationsLimit: number = config.notificaitonsPageSize;
  othersNotificationsLimit: number = config.notificaitonsPageSize;
  notificaitonsSkip: number = 0;
  otherCount: any = '';
  urgentCount: any = '';
  isDismissedNotif: boolean = true;
  loader = {
    urgentNotification: false,
    otherNotification: false,
  };
  constructor(
    private helperService: HelperService,
    private router: Router,
    private dataService: DataService,
    private httpService: HTTPService,
    private dialogService: DialogService,
  ) {}

  ngOnInit() {
    this.deletedElement = -1;
    this.getNotification();
    this.setDataListener();
    this.setSidebarZIndex();
  }

  ngOnDestroy() {
    this.clearListeners();
  }

  getNotification() {
    this.getUrgentNotifications();
    this.getOthersNotifications();
  }

  clearListeners() {
    this.dataListeners.forEach((subscribe) => {
      if (subscribe) {
        subscribe.unsubscribe();
      }
    });
  }

  setDataListener() {
    this.dataListeners.push(
      this.dataService.getData().subscribe((payload: any) => {
        console.log('listener: notification-sidepanel.component.ts');
        if (payload?.data?.type === 'passdata' && payload?.data?.key === 'fetch-notifications') {
          // // this.fetchNotifications.emit();
          this.getNotification();
        }
      }),
      this.dataService.getClickEvent().subscribe((target) => {
        console.log('listener: notification-sidepanel.component.ts');
        const sidebarShade = document.querySelector('.p-sidebar-mask');
        if (sidebarShade && sidebarShade.contains(target)) {
          this.onSidebarOutside();
        }
      }),
    );
  }

  getUrgentNotifications() {
    this.loader.urgentNotification = true;
    const conf = {
      limit: this.urgentnotificationsLimit,
      offset: 0,
      sortField: 'createdAt',
      search: '',
      sortOrder: '-1',
      priority: this.index === 0 ? 'urgent' : this.index === 1 ? 'normal' : 'urgent',
    };
    this.deletedElement = -1;
    this.httpService
      .getLatestNotifications(conf)
      .then(
        (res) => {
          this.urgentCount = res.urgentCount;
          this.urgentNotifications = res.records.length > 0 ? res.records : [];
          this.urgentNotificationsTotalRecord = res.unreadCount || 0;
        },
        (error) => {
          this.helperService.showToaster('error', error);
        },
      )
      .finally(() => {
        this.loader.urgentNotification = false;
      });
  }

  getOthersNotifications() {
    this.loader.otherNotification = true;
    const conf = {
      limit: this.othersNotificationsLimit,
      offset: 0,
      sortField: 'createdAt',
      search: '',
      sortOrder: '-1',
      priority: 'normal',
    };

    this.httpService
      .getLatestNotifications(conf)
      .then(
        (res) => {
          this.otherCount = res.otherCount;
          this._notifications.old = res.records.length > 0 ? res.records : [];
          this.othersNotificationsTotalRecord = res.unreadCount || 0;
        },
        (error) => {
          this.helperService.showToaster('error', error);
        },
      )
      .finally(() => {
        this.loader.otherNotification = false;
      });
  }

  scrollingFinished(isMarkRead?) {
    if (!isMarkRead) {
      this.notificaitonsSkip += config.notificaitonsPageSize;
      if (this.index === 0) {
        this.urgentnotificationsLimit += config.notificaitonsPageSize;
        this.getUrgentNotifications();
      } else if (this.index === 1) {
        this.othersNotificationsLimit += config.notificaitonsPageSize;
        this.getOthersNotifications();
      }
    }
  }

  onUrgentNotificaitonsClick() {
    const body = {
      ids: [],
    };
    this.urgentNotifications.forEach((item) => {
      if (!item.isSeen) {
        body.ids.push(item._id);
      }
    });
    if (body.ids.length) {
      this.httpService.UpdateNotificationsStatus(body).then(
        (res) => {},
        (error) => {
          this.helperService.showToaster('error', error);
        },
      );
    }
  }

  onOthersNotificaitonsClick() {
    const body = {
      ids: [],
    };
    this.urgentNotifications.forEach((item) => {
      if (!item.isSeen) {
        body.ids.push(item._id);
      }
    });
    if (body.ids.length) {
      this.httpService.UpdateNotificationsStatus(body).then(
        (res) => {},
        (error) => {
          this.helperService.showToaster('error', error);
        },
      );
    }
  }

  onSidebarOutside() {
    this.clearListeners();
    this.isSidebarVisible = false;
    this.setNotificationPanelState.emit(false);
    this.fetchNotifications.emit(false);
  }

  setSidebarZIndex() {
    try {
      setTimeout(() => {
        const sidebar = document.querySelector('#follow-up-sidebar');
        const dialogs = document.querySelectorAll('p-dynamicdialog');
        let highestZIndex = 0;
        if (dialogs && dialogs.length) {
          dialogs.forEach((dialog: any) => {
            const style = dialog.children && dialog.children[0] && dialog.children[0].style;
            if (style.zIndex && Number(style.zIndex) > highestZIndex) {
              highestZIndex = Number(style.zIndex);
            }
          });
        }
        if (highestZIndex) {
          const sidebarContainer: any = sidebar.querySelector('.p-sidebar');
          if (sidebarContainer) {
            const sidebarOverlay: any = document.querySelector('.p-sidebar-mask');
            sidebarOverlay.style.zIndex = highestZIndex;
            sidebarContainer.style.zIndex = `${highestZIndex + 1}`;
          }
        }
      }, 100);
    } catch (err) {
      console.log(err);
    }
  }

  /** Removing click outside listener */
  // handleUnsubscribleClickoutside() {
  //   if (this.clickOutsideListener) {
  //     this.clickOutsideListener.unsubscribe();
  //   }

  //   this.clickOutsideListener = null;
  // }

  /** Reset data when sidebar is closed */
  handleHideSidebar() {
    this.onSidebarOutside();
  }

  /** Handle tab change in sidebar */
  handleTabChange({ index }) {
    this.index = index;
    //this.getNotification();
    if (this.index === 0) this.getUrgentNotifications();
    if (this.index === 1) this.getOthersNotifications();
  }

  handleAssignTech(param: any) {
    this.changeNotificationStatus(param);
    this.httpService.getOrderInitData(param.moduleId).then(
      (data) => {
        if (data) {
          const { technicians, appsettings, services } = data;
          this.isWorkAsTechEnabled = appsettings.appsettings.isWorkAsTechEnabled;

          technicians.forEach((tech: any) => {
            tech.name = `${tech.firstName} ${tech.lastName}`;
          });

          this.technicians = [this.unAssignTech, ...technicians.filter(({ role, isWorkAsTechEnabled }) => role === 'tech' || isWorkAsTechEnabled)];

          const component = MultiTechAssignDialogComponent;
          const ref = this.dialogService.open(component, {
            width: '1000px',
            styleClass: `add-dialog multi-tech-assign-dialog`,
            showHeader: false,
            data: {
              serviceId: '',
              orderId: param.moduleId,
              techs: this.technicians,
              estimateId: param.moduleId,
              services: services,
              notificationId: param._id,
              source: 'notification',
            },
          });
          const onClose = ref.onClose.subscribe(({ isSuccess }) => {
            if (isSuccess) {
              // this.getEstimatesById(this.estimate._id);
              this.getUrgentNotifications();
              // this.fetchNotifications.emit();
            }

            onClose.unsubscribe();
          });
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  handleScheduleAppointment(notif) {
    this.changeNotificationStatus(notif);
    notif.source = 'notification';
    notif.notificationId = notif._id;
    if (notif.moduleId) {
      this.httpService.getAppointmentRequestById(notif.moduleId).then(
        (result) => {
          this.openScheduleAppointment(result, notif);
        },
        (err) => {
          console.error(err);
        },
      );
    }
  }

  openScheduleAppointment(props, param) {
    props.param = param;
    const start = this.helperService.convertDate(props.start);
    const end = this.helperService.convertDate(props.start).add(60, 'minutes');
    this.dataService.sendData(
      this.dataService.typeDialog('add-appointment', 'calendar-view', null, null, {
        startDate: start.toDate(),
        endDate: end.toDate(),
        startTime: `${start.format('HH')}:${start.format('mm')}`,
        endTime: `${end.format('HH')}:${end.format('mm')}`,
        props: props,
      }),
    );
  }

  redirectToEstimate(param) {
    if (param.data) {
      this.changeNotificationStatus(param);
      const { serviceId, techId } = param.data;
      const data = { serviceId: serviceId, orderId: param.moduleId, isScroll: true, techId: techId, type: 'techFlag' };
      // const data = { serviceId: '65261f943cd6a70cb8bf7e3e', orderId: '652615543cd6a70cb8bf7cf7' , isScroll: true, techId: '63c914a45eda71002330461d', type: 'techFlag', };
      localStorage.setItem('showFlagCard', JSON.stringify(data));
      this.helperService.openPageInNewExistingTab(`/estimate/${param.moduleId}`, param.moduleId);
    }
  }

  goToEstimate(estimate: any) {
    this.changeNotificationStatus(estimate);
    if (estimate.moduleId) {
      this.helperService.openPageInNewExistingTab(`/estimate/${estimate.moduleId}`, estimate.moduleId);
    }
  }

  redirectToPart(name, item) {
    this.changeNotificationStatus(item);
    if (name === 'parts') {
      this.helperService.saveLocalStorage('pn', item.moduleId);
      this.helperService.openPageInNewTab(config.redirectUrl.parts);
    } else if (name === 'calendar') {
      const moduleId = item.moduleId;
      this.helperService.saveLocalStorage('an', moduleId);
      this.dataService.sendData(this.dataService.typePassData('load-notifications', true));
      const url = `${config.redirectUrl.calendar}?moduleId=${moduleId}`;
      this.helperService.openPageInNewTab(url);
    } else if (name === 'order' || name === 'order - estemate' || name === 'order - payment') {
      const url = [`/estimate/${item.moduleId}`];

      if (item.entityType === 'employees' && item.entityAction === 'requestAccess') {
        url.push(`?userRequest=${item.entityTypeId}`);
      }

      this.helperService.openPageInNewExistingTab(url.join(''), item.moduleId);
    } else if (name === 'reviews') {
      this.helperService.openPageInNewTab(config.redirectUrl.reviewsSummary);
    } else if (name === 'statement') {
      if (item.moduleId && item.entityTypeId) {
        this.helperService.openPageInNewTab(`${config.redirectUrl.customerCenter}/${item.moduleId}?statementId=${item.entityTypeId}`);
      } else {
        this.helperService.openPageInNewTab(`${config.redirectUrl.statementList}`);
      }
    } else if (name === 'QBO') {
      this.helperService.openPageInNewTab(`${config.redirectUrl.qboPostingReport}?itemId=${item._id}`);
    } else if (name === 'transferOrder') {
      this.helperService.openPageInNewTab(`${config.redirectUrl.transferStock}/${item?.moduleId}`);
    }
  }

  showTime(date) {
    if (date) {
      const result = this.helperService.fromNow(date);
      if (result === 'a minute ago') {
        return '1 min';
      } else if (result === 'an hour ago') {
        return '1 hour';
      } else if (result === 'a few seconds ago') {
        return '1 min';
      } else {
        const resultArr = result.split(' ');
        return `${resultArr[0]} ${resultArr[1]}`;
      }
    }
  }

  handleMarkeRead(data: any) {
    const body = {
      ids: [],
    };
    data.forEach((item) => {
      if (!item.isSeen) {
        body.ids.push(item._id);
      }
    });
    if (body.ids.length) {
      this.httpService.UpdateNotificationsStatus(body).then(
        (res) => {
          this.scrollingFinished(false);
        },
        (error) => {
          console.error(error);
        },
      );
    } else {
      this.scrollingFinished(false);
    }
  }

  changeNotificationStatus(item) {
    const body = {
      ids: [],
    };
    if (!item.isSeen) {
      body.ids.push(item._id);
    } else {
      return;
    }
    this.httpService.UpdateNotificationsStatus(body).then(
      (res) => {
        this.scrollingFinished(false);
        // this.fetchNotifications.emit();
      },
      (error) => {
        console.error(error);
      },
    );
  }

  openContactUpdateDialog(param: any) {
    this.changeNotificationStatus(param);
    const { costumer } = param.data;
    param.source = 'notification';
    param.notificationId = param._id;
    param.contactEntityType = 'customer';
    this.httpService.getContactInfo(param.createdBy, false, param).then(
      (contact) => {
        this.contact = contact;
        const ref = this.dialogService.open(UpdateContactDialogComponent, {
          closeOnEscape: false,
          width: '650px',
          styleClass: 'add-dialog add-receipt-modal update-contact-dialog',
          showHeader: false,
          data: {
            contactEntityId: param.createdBy,
            email: costumer.email,
            phone: costumer.phone,
            contact: this.contact,
          },
        });

        const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
          if (isSuccess) {
          }
          onClose.unsubscribe();
        });
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  onScroll = debounce((event) => {
    const element = event.target;

    if (element.scrollHeight - element.scrollTop - element.clientHeight < 10) {
      // this.scrollingFinished.emit(false);
      if (this.index === 1) {
        this.handleMarkeRead(this._notifications.old);
      } else if (this.index === 0) {
        this.handleMarkeRead(this.urgentNotifications);
      }
    }
  }, 600);

  openEstimate(estime: any) {
    this.changeNotificationStatus(estime);
    this.helperService.openPageInNewExistingTab(`/estimate/${estime.moduleId}`, estime.moduleId);
  }

  markAllRead() {
    this.httpService
      .markAllReadNotifications()
      .then(
        (res) => {
           this.scrollingFinished(true);
        },
        (error) => {
          console.error(error);
        },
      )
      .finally(() => {
        this.fetchNotifications.emit();
      });
    this.onSidebarOutside();
  }

  handleResetData() {}

  ViewAll() {
    this.onSidebarOutside();
    this.router.navigate([`/activity-logs`]);
  }

  dismissNofication(e, data) {
    if (!data.isDismissed) {
      this.httpService.dismissNotifications(data, { isDismissed: false }).then(
        (res) => {
          const conf = {
            limit: this.urgentnotificationsLimit,
            offset: 0,
            sortField: 'createdAt',
            search: '',
            sortOrder: '-1',
            priority: 'urgent',
          };
          this.deletedElement = this.urgentNotifications.findIndex((e) => data._id === e._id);
          if (this.deletedElement !== -1) {
            this.urgentNotifications.splice(this.deletedElement, 1);
            if (this.urgentCount > 0) {
              this.urgentCount = this.urgentCount - 1;
            }
            this.deletedElement = -1;
          }

          this.fetchNotifications.emit();
        },
        (error) => {
          console.error(error);
        },
      );
    }
  }

  dismissOtherNofication(e, data) {
    if (!data.isDismissed) {
      this.httpService.dismissNotifications(data, { isDismissed: false }).then(
        (res) => {
          const conf = {
            limit: this.othersNotificationsLimit,
            offset: 0,
            sortField: 'createdAt',
            search: '',
            sortOrder: '-1',
            priority: 'normal',
          };
          this.deletedElement = this._notifications.old.findIndex((e) => data._id === e._id);
          if (this.deletedElement !== -1) {
            this._notifications.old.splice(this.deletedElement, 1);
            if (this.otherCount > 0) {
              this.otherCount = this.otherCount - 1;
            }
            this.deletedElement = -1;
          }

          this.fetchNotifications.emit();
        },
        (error) => {
          console.error(error);
        },
      );
    }
  }

  dismissAllNofication() {
    if (!this.isDismissedNotif) return;
    this.isDismissedNotif = false;
    const ids = [];
    if (this.index === 0) {
      this.urgentNotifications.forEach((item) => {
        ids.push(item._id);
      });
    } else if (this.index === 1) {
      this._notifications.old.forEach((item) => {
        ids.push(item._id);
      });
    }
    this.httpService.dismissAllNotifications('all', { isDismissed: false, priority: this.index === 1 ? 'normal' : 'urgent', ids }).then(
      (res) => {
        if (this.index === 0 && this.urgentNotifications.length) {
          this.helperService.showToaster('success', 'Notification dismissed');
        }
        if (this.index === 1 && this._notifications.old.length) {

          this.helperService.showToaster('success', 'Notification dismissed');
        }
        this.urgentNotifications = [];
        this._notifications.old = [];
        this.scrollingFinished(false);
        this.fetchNotifications.emit();
        this.dismissEvent.emit()
        this.isDismissedNotif = true;
      },
      (error) => {
        console.error(error);
      },
    );
  }
}
